/* RESPONSIBLE TEAM: team-workflows */
export default class StaticEdge {
  get isStatic() {
    return true;
  }
}
